import { sendRequest } from '../../common/utils';
import { getLocale } from '../../providers';

export const fetchOnlineServices = ({ params }) => {
    const { applicationType, selectedTab } = params;
    let service = '/favorites';
    const lang = getLocale();
    if (selectedTab === 'all') {
        service += '/all';
    }
   
    return sendRequest({
        url: `${service}/${applicationType}/${lang}`,
        method: 'GET',
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, extraInfo: error.extraInfo, code: error.code, details: error.details } };
        });
};

export const favoriteOnlineServices = ({ params }) => {
    const { applicationType, requestBody, isFavoritesPage } = params;
    const lang = getLocale();
    return sendRequest({
        url: `/favorites/${applicationType}/${lang}`,
        method: 'POST',
        body: {
            ...requestBody,
            isFavoritesPage: isFavoritesPage
        },
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, extraInfo: error.extraInfo, code: error.code, details: error.details } };
        });
};
